import {
  Autocomplete,
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SimCardDownloadOutlinedIcon from "@mui/icons-material/SimCardDownloadOutlined";
import ModalTable from "../../../../../components/utils/modalTable/modalTable";

const allOutletOption = { id: 0, fullname: "All" };

const statusOptions = [
  { id: null, name: "All" },
  { id: 1, name: "Approved" },
  { id: 0, name: "Un Approve" },
];

const OtPurchaseReturn = () => {
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [prLines, setPrLines] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [supplier, setSupplier] = useState([]);
  const [cust, setCust] = useState(allOutletOption);
  const [status, setStatus] = useState(statusOptions[0]);
  const [totalFlag, setTotalFlag] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const roleId = localStorage.getItem("role_id");
  const isAuthorized = roleId == 1 || roleId == 2;
  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().startOf("month").format(),
    toDate: moment().format(),
  });

  const onEdit = (e) => {
    setPrLines(e.row.pr_lines || []);
    setRowData(e.row);
    setOpen(true);
  };

  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data || []);
        setCust(allOutletOption);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response?.data?.error));
      });
  }

  const getStatusLabel = (row) => {
    if (row.is_approved === 1) return "Approved";
    if (row.is_approved === 0) return "Un Approve";
    return "N/A";
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      width: 70,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "date1",
      headerName: "Date",
      flex: 1,
      minWidth: 110,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "docNo",
      headerName: "Doc No",
      flex: 1.5,
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "outlet_name",
      headerName: "Outlet",
      flex: 1.5,
      minWidth: 160,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "totalqty",
      headerName: "Total Qty",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => <strong>{params.value}</strong>,
    },
    {
      field: "approve",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const isApproved = params.row.is_approved === 1;
        return (
          <Typography
            sx={{
              backgroundColor: isApproved ? "#2e7d32" : "#ed6c02",
              color: "#fff",
              px: 1.5,
              py: 0.5,
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: 600,
              textAlign: "center",
              minWidth: "90px",
            }}
          >
            {params.value}
          </Typography>
        );
      },
    },
    {
      field: "view",
      headerName: "View",
      disableExport: true,
      width: 80,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <IconButton size="small" onClick={() => onEdit(params)}>
          <VisibilityIcon sx={{ fontSize: 18 }} />
        </IconButton>
      ),
    },
  ];

  const rows = _.map(data, (val, idx) => ({
    id: val.id,
    sno: idx + 1,
    date1: moment(val.date).format("DD-MM-YYYY"),
    docNo: val.docno,
    outlet_name: val.outlet_name || "-",
    totalqty: val.totalqty,
    amount: parseFloat(val.amount).toFixed(0),
    approve: getStatusLabel(val),
    is_approved: val.is_approved,
    pr_lines: val.pr_lines,
    tot_amt: parseFloat(val.amount).toFixed(0),
    documentNo: val.docno,
    documentDate: moment(val.date).format("DD-MM-YYYY"),
  }));

  const props = {
    columns,
    rows,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    pageCount,
    pageOption,
    totalAmount,
    totalFlag,
  };

  const tableHeadData = [
    { id: 1, label: "S No" },
    { id: 2, label: "Barcode" },
    { id: 3, label: "Product" },
    { id: 4, label: "Rate" },
    { id: 5, label: "Qty" },
    { id: 6, label: "Amount" },
    { id: 7, label: "Reason" },
  ];

  const tableBodyData = _.map(prLines, (val, idx) => ({
    id: idx,
    sNo: idx + 1,
    name: val.barcode,
    pro_name: val.pro_name,
    Rate: val.rate,
    Qty: val.qty,
    totalAmount: parseFloat(val.amount || 0).toFixed(2),
    reason: val.reason || "-",
  }));

  function handleChange(e, name) {
    setDateLimit((prev) => ({ ...prev, [name]: dayjs(e).format() }));
  }

  const formatBillDate = (value) =>
    value ? moment(value).format("DD-MMM-YYYY") : "-";

  const exportToExcel = async () => {
    if (!data.length) {
      dispatch(setSnackbar(true, "error", "No data available for download."));
      return;
    }

    try {
      setDownloading(true);
      await new Promise((resolve) => setTimeout(resolve, 50));

      const appliedFrom = moment(dateLimit.fromDate).format("DD-MM-YYYY");
      const appliedTo = moment(dateLimit.toDate).format("DD-MM-YYYY");
      const appliedOutlet = cust?.fullname || "All";
      const appliedStatus = status?.name || "All";

      const header = [
        "Doc No",
        "Total Items",
        "Date",
        "Outlet",
        "Status",
        "Bill Amount",
        "Barcode",
        "Product",
        "Rate",
        "Qty",
        "Line Amount",
        "Reason",
      ];

      const aoa = [
        ["Outlet Purchase Return Report"],
        [`Date Range: ${appliedFrom} to ${appliedTo}`],
        [`Outlet: ${appliedOutlet} | Status: ${appliedStatus}`],
        [],
        header,
      ];
      const merges = [];
      let grandTotalQty = 0;
      let grandTotalAmount = 0;

      data.forEach((bill) => {
        const lines = bill.pr_lines?.length ? bill.pr_lines : [null];
        const groupStartRow = aoa.length;
        const billAmount = Math.round(parseFloat(bill.amount || 0));
        const billQty = lines.reduce(
          (sum, line) => sum + (Number(line?.qty) || 0),
          0,
        );
        grandTotalQty += billQty;
        grandTotalAmount += billAmount;

        lines.forEach((line, idx) => {
          aoa.push([
            idx === 0 ? bill.docno : "",
            idx === 0 ? lines.length : "",
            idx === 0 ? formatBillDate(bill.date) : "",
            idx === 0 ? bill.outlet_name || "-" : "",
            idx === 0 ? getStatusLabel(bill) : "",
            idx === 0 ? billAmount : "",
            line?.barcode ? String(line.barcode) : "",
            line?.pro_name || "",
            line ? parseFloat(line.rate || 0).toFixed(2) : "",
            line?.qty ?? "",
            line ? parseFloat(line.amount || 0).toFixed(2) : "",
            line?.reason || "",
          ]);
        });

        if (lines.length > 1) {
          const groupEndRow = groupStartRow + lines.length - 1;
          [0, 1, 2, 3, 4, 5].forEach((col) => {
            merges.push({
              s: { r: groupStartRow, c: col },
              e: { r: groupEndRow, c: col },
            });
          });
        }
      });

      aoa.push([
        "",
        "",
        "",
        "",
        "Grand Total",
        Math.round(grandTotalAmount),
        "",
        "",
        "",
        grandTotalQty,
        Math.round(grandTotalAmount),
        "",
      ]);

      const ws = XLSX.utils.aoa_to_sheet(aoa);
      ws["!merges"] = merges;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Purchase Return Report");
      XLSX.writeFile(
        wb,
        `ot_purchase_return_report_${moment().format("YYYY-MM-DD")}.xlsx`,
      );
    } catch (error) {
      console.error(error);
      dispatch(setSnackbar(true, "error", "Failed to export report."));
    } finally {
      setDownloading(false);
    }
  };

  function handlePurchaseReturnReport() {
    if (!isAuthorized) return;
    const postData = {
      from_date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      to_date: moment(dateLimit.toDate).format("YYYY-MM-DD"),
      customer: cust?.id ?? 0,
    };
    if (status && status.id !== null && status.id !== undefined) {
      postData.status = status.id;
    }
    axios
      .post("/v1/reports/outlet/purchase/return", postData)
      .then((res) => {
        setData(res.data);
        setPageCount(res.data.length);
      })
      .catch(() => {
        setData([]);
        setPageCount(0);
        dispatch(setSnackbar(true, "error", "No Data Found"));
      });
  }

  useEffect(() => {
    setTotalFlag(true);
    let total = 0;
    data.forEach((val) => {
      total += parseFloat(val.amount);
    });
    setTotalAmount(total.toFixed(0));
  }, [data]);

  useEffect(() => {
    if (!isAuthorized) return;
    if (dateLimit.fromDate !== null && dateLimit.toDate !== null && cust) {
      handlePurchaseReturnReport();
    }
  }, [rowsPerPage, page, dateLimit, cust, status]);

  useEffect(() => {
    if (isAuthorized) {
      getSupplierData();
    }
  }, []);

  if (!isAuthorized) {
    return (
      <Fragment>
        <Helmet>
          <title>Ot Purchase Return Reports</title>
        </Helmet>
        <Typography variant="h6" sx={{ p: 2 }}>
          Access denied. Only Role 1 and Role 2 can view this report.
        </Typography>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Helmet>
        <title>Ot Purchase Return Reports</title>
      </Helmet>
      <Typography variant="h6">Ot Purchase Return Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2" alignItems="center">
        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={cust}
            options={[allOutletOption, ...supplier]}
            onChange={(e, value) => setCust(value || allOutletOption)}
            getOptionLabel={(option) => option.fullname}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Outlet"
                InputProps={{
                  ...params.InputProps,
                  readOnly: true,
                }}
              />
            )}
          />
        </Grid>
        <Grid item md={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: "From",
                  style: { width: "100%" },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: "To",
                  style: { width: "100%" },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={2}>
          <Autocomplete
            size="small"
            value={status}
            options={statusOptions}
            onChange={(e, value) => setStatus(value || statusOptions[0])}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Status" />
            )}
          />
        </Grid>
        <Grid item md={12} className="flex justify-end">
          <Button
            variant="contained"
            size="small"
            onClick={exportToExcel}
            disabled={!data.length || downloading}
            endIcon={
              downloading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <SimCardDownloadOutlinedIcon />
              )
            }
          >
            {downloading ? "Exporting…" : "Export to Excel"}
          </Button>
        </Grid>
      </Grid>
      <CustomTable props={props} />
      <Backdrop open={downloading} sx={{ zIndex: 9998, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Backdrop open={open} sx={{ zIndex: 9999 }}>
        <ModalTable
          tableHeadData={tableHeadData}
          tableBodyData={tableBodyData}
          setOpen={setOpen}
          data={rowData}
        />
      </Backdrop>
    </Fragment>
  );
};

export default memo(OtPurchaseReturn);
